var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRalvieLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 50,
    viewBox: "0 0 189.273 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ralvie_Logo",
    "data-name": "ralvie Logo",
    transform: "translate(-407.178 -362.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M21.667,50h0Zm-1.717-.067h0a21.465,21.465,0,0,1-7.827-2.143A21.679,21.679,0,0,1,1.661,20H15a5,5,0,1,1,0,10H5.452l3.077,4.231L10.3,36.667,19.95,49.933ZM26.3,49.5h0L16.861,36.52A11.667,11.667,0,0,0,15,13.334H6.031a21.706,21.706,0,0,1,6.992-4.875,21.5,21.5,0,0,1,4.163-1.329,21.866,21.866,0,0,1,8.847-.024,21.544,21.544,0,0,1,7.747,3.26,21.732,21.732,0,0,1,7.85,9.533,21.531,21.531,0,0,1,1.262,4.067,21.684,21.684,0,0,1-9.821,22.791A21.5,21.5,0,0,1,26.3,49.5ZM24.166,5h-5A2.5,2.5,0,0,1,17.4.732,2.484,2.484,0,0,1,19.166,0h5a2.5,2.5,0,0,1,1.768,4.268A2.482,2.482,0,0,1,24.166,5Z",
    transform: "translate(407.178 362.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_407",
    "data-name": "Union 407",
    d: "M0,36.667V10.389H4.591v4.327A10.333,10.333,0,0,1,13.666,9.6v4.538a4,4,0,0,0-.792-.053c-5.013.159-8.284,3.483-8.284,8.654v13.93ZM103,22.625c0-8.031,5.638-14.042,13.4-14.042,8.137,0,12.871,6.383,12.871,13.138a11.285,11.285,0,0,1-.16,2.287H107.307c.638,6.223,5.159,8.829,9.573,8.829a8.786,8.786,0,0,0,7.712-4.1l3.3,2.234a12.6,12.6,0,0,1-11.063,5.691C108.583,36.667,103,30.763,103,22.625Zm4.414-2.181h17.605c-.426-4.149-3.351-8.085-8.563-8.085A9.194,9.194,0,0,0,107.413,20.445ZM92.421,36.667V10.179h4.628V36.667ZM60.267,9.116h4.84l9.149,19.147,9.1-19.147h4.787L74.2,36.667Zm-8.8,27.551V0H56.1V36.667Zm-12.635,0v-6.01a11.673,11.673,0,0,1-10.319,6.01C20.8,36.667,15,30.71,15,22.732c0-8.138,5.851-14.148,13.669-14.148a11.37,11.37,0,0,1,10.212,6.063L43.3,7.892V36.667Zm-19.2-13.988A9.392,9.392,0,0,0,29.2,32.465a9.84,9.84,0,0,0,.106-19.679A9.5,9.5,0,0,0,19.628,22.679ZM91.3,3.458A3.439,3.439,0,0,1,94.708,0a3.521,3.521,0,0,1,3.457,3.458,3.511,3.511,0,0,1-3.457,3.4A3.394,3.394,0,0,1,91.3,3.458Z",
    transform: "translate(467.178 369.995)",
    fill: "#f8f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalvieLogoDark);
export default __webpack_public_path__ + "static/media/ralvieLogoDark.ff4199400900ff70a50a243d2ff3d1dc.svg";
export { ForwardRef as ReactComponent };